export default __webpack_public_path__ + "images/62b68733e.png";